import MenuDivider from './MenuDivider';

export default MenuDivider;
